import Entity from './entity'

const DebtorContact = new Entity('debtorcontacts')

export default DebtorContact
